import { BankDetailTimelineProps } from './BankDetailsTimeline.types'
import { BankDetailsTimelineTable } from './BankDetailsTimelineTable'

export function BankDetailsTimeline({ data, isLoading, error, sortOrder = 'desc' }: BankDetailTimelineProps) {
  return <BankDetailsTimelineTable isLoading={isLoading} data={data} error={!!error} sortOrder={sortOrder} />
}
